import React, { useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { usePublicprofileTeacherQuery } from '../../slices/teachers/teachersApiSlice';
import { useGetPublicsubjectsQuery } from '../../slices/teachers/subjectApiSlice';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import PublicSubject from '../../components/PublicSubject';
import { colors45 } from '../../colorConstant';

const TeacherPublicProfile = () => {

    const { id } = useParams();
    const myRef = useRef(null)
    const colors2 = [];
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [jobtitle, setJobtitle] = useState('');
    const [about, setAbout] = useState('');
    const [teacherid, setteacherid] = useState('');
    const [image, setImage] = useState('');
    const [mysubjects, setMysubjects] = useState([]);

    const { data, isLoading, error, } = usePublicprofileTeacherQuery(id);

    useEffect(() => {
        setFirstname(data?.firstname);
        setLastname(data?.lastname);
        setJobtitle(data?.jobtitle);
        setImage(data?.image);
        setAbout(data?.about);
        setteacherid(data?._id);
      }, [data?.firstname, data?.lastname, data?.image, data?.jobtitle, data?.about]);

    const { data: subjects, isLoading: loading, error: err, } = useGetPublicsubjectsQuery(teacherid);

    useEffect(() => {
        setMysubjects(subjects);
    }, [subjects?.length]);

    for (let i = 0; i < subjects?.length; i++) {
        colors2.push(colors45[i]);
    }

    const executeScroll = () => {
        myRef.current.scrollIntoView()    
    }

    return (
        <div className="bg23">
        <div className="bg-default2 ">
            <nav id="navbar-main" class="navbar navbar-horizontal navbar-transparent navbar-main navbar-expand-lg navbar-light navPubpro">
                <div class="container">
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="navbar-collapse navbar-custom-collapse collapse " id="navbar-collapse">
                    <div class="navbar-collapse-header">
                    <div class="row">
                        <div class="col-6 collapse-close">
                        <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
                            <span></span>
                            <span></span>
                        </button>
                        </div>
                    </div>
                    </div>
                    <ul class="navbar-nav ">
                    <li class="nav-item">
                        <a href="../../pages/dashboards/dashboard.html" class="nav-link">
                        {/* <span class=" logP">ASK TO LEARN</span> */}
                        <span className=" logP" style={{textTransform: 'capitalize'}}>ask {firstname} {lastname}</span>

                        </a>
                    </li>
                    
                    </ul>
                    <hr class="d-lg-none" />
                    <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                    <li className="nav-item">
                        <LinkContainer to="/studentlogin" className=''>
                            <span className="nav-link nav-link-icon">Login</span>
                        </LinkContainer >
                    </li>
                    <li className="nav-item">
                        <LinkContainer to="/studentregister" className=''>
                            <span className="nav-link nav-link-icon">Register</span>
                        </LinkContainer >
                    </li>
                    </ul>
                </div>
                </div>
            </nav> 
            <div className="main-content maincont" >
                <div className="container-fluid mt--5 loginResponsive">
                    <div className="header  py-5 py-lg-6 pt-lg-7">
                    </div> 
                    <div className="container mt--10 pb-5 containerP">
                        {isLoading ? ( 
                            <Loader /> 
                        ) : error ? ( 
                            <Message variant='danger'>
                                {error?.data?.message || error.error}
                            </Message> ) 
                            : (
                            <>                                                    
                                <div class="row bg-gradient-primary contxt2">
                                        <div class=" offset-lg-1 col-lg-5 text-center prof11">
                                            <h1 className="display-3 text-white nameP" style={{textTransform: 'capitalize'}}>
                                                {firstname} {lastname}
                                            </h1>
                                            <p class="text-white mt-0 mb-7 titleP2" style={{textTransform: 'capitalize'}}>
                                            {jobtitle}
                                            </p>
                                        </div>
                                        <div class="col-lg-5 prof11">
                                            <div class="card-profile-image profileImg2">
                                                <>
                                                {image != 'none' ? (
                                            <a href="#"><br />
                                                <img src={`https://bucketeer-f3a53e81-2e13-49e9-82ca-c504e025aced.s3.amazonaws.com/public/profiles/${image}`}
                                                 class=" imageP newImgt" />
                                            </a>
                                            ) : (
                                                <img src={`../../assets/img/10542486.png`} class=" imageP" />
                                            )}
                                            </>
                                            <btn href="#!" class="btn btn-danger btnP btnprof" onClick={executeScroll}>
                                                Ask me a question</btn><br /><br /><br />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row ">
                                    <div class="offset-lg-1 col-lg-10  aboutP"><br /><br /><br /> <br /> 
                                        <h3 class="display-5 text-white">About me:</h3><br /> 
                                        <p class="text-white mt-0 mb-5 aboutT" >
                                            {about}
                                        </p>
                                    </div>
                                    <div class="row">
                                    <div class="offset-lg-1 col-lg-10 aboutP aboutP34"><br /> <br /> <br /> <br /> 
                                        <h3 class="display-5 text-white">You can ask me about:</h3><br /><br />
                                        <div class="row" ref={myRef}>
                                        {mysubjects?.map((subject, index) => (
                                            <div key={subject._id} className="col-md-6 col-xl-4 textCard43">
                                                <PublicSubject subject={subject} color={colors2[index]}  />
                                            </div>
                                        ))}
                                        </div>
                                    </div>
                                    </div>   
                                </div>
                            </>
                        )}
                    </div>
                    <footer className="py-2 " id="footer-main">
                        <div className="container ">
                            <div className="row align-items-center ">
                                <div className="col-xl-5 ">
                                <div className="copyright text-center text-xl-left ">
                                <span className='text-white'>  &copy; 2025</span> <a  className="font-weight-bold ml-1 text-white" target="_blank">Ask to Learn</a>
                                </div>
                                </div>
                                <div className="col-xl-6 ">
                                    <ul className="nav nav-footer justify-content-center justify-content-xl-end ">
                                        <li className="nav-item ">
                                        <a  className="nav-link text-white" target="_blank">Categories</a>
                                        </li>
                                        <li className="nav-item">
                                        <a  className="nav-link text-white" target="_blank">About Us</a>
                                        </li>
                                        <li className="nav-item">
                                        <a  className="nav-link text-white" target="_blank">Blog</a>
                                        </li>
                                        <li className="nav-item">
                                        <a  className="nav-link text-white" target="_blank">License</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </footer>
                </div>       
            </div>
        </div>
        </div>

    )
}

export default TeacherPublicProfile
